<template>
  <div id="app">
    <root/>
  </div>
</template>

<script>
import Root from '@/components/root';

export default {
  components: {
    Root,
  },
};
</script>

<style lang="scss">
  @import '~@/assets/scss/fontfaces';
  @import '~@/assets/scss/media.scss';

  .flex-100 {
    flex: 1 0 100%;
  }

  @include only-desktop {
    .l\:flex-100 {
      flex: 1 0 100%;
    }
  }
</style>

<style lang="postcss">
  @tailwind base;
  @tailwind components;
  @tailwind utilities;

  #app {
    font-family: 'FAZGoldSans-Regular', "helvetica neue", helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
    text-align: center;
    color: #2c3e50;
    max-width: 1000px;
  }

  html {
    overflow: hidden;
  }

  button:focus {
    outline: none;
  }
</style>
